export const projectNavOptions = {
  Projects: "projects",
  Insurance: "insurance",
  Financials: "financials",
  RiskManagement: "riskManagement",
  AssetManagement: "assetManagement",
  ReportingYear: "reportingYear",
};
